import { render, staticRenderFns } from "./AnalyticsSafeguarding.vue?vue&type=template&id=7ab7ddd8&"
import script from "./AnalyticsSafeguarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsSafeguarding.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports